<div class="striped-bg"></div>
<section id="home-about">
	<div class="no-overflow">
		<div class="section-main">
			@defer (on viewport; when forceLoad) {
				<div id="home-about-top" @deferState>
					<h2 [innerHTML]="about?.fields?.title || 'Something went wrong.'"></h2>
				</div>
			} @placeholder {
				<div class="defer-ph"></div>
			}
			@defer (on viewport; when forceLoad) {
				<div *ngIf="about?.fields; else noAbout" id="home-about-main" @deferState>
					<div id="about-info-container">
						<div id="about-info-main">
							<h2 [innerHTML]="about.fields.subtitle"></h2>
							<p [innerHTML]="contentService.docToHTML(about.fields.entry).split('<!--intro-end-->')[0]"></p>
							<div class="entry-btn-wrap">
								<a class="button" href="#" (click)="selectAbout($event); false;">Full Bio</a>
							</div>
						</div>
					</div>
					<div id="about-img-wrap" [style.background-image]="'url(' + about.fields.backgroundImage.fields.file.url + ')'">
						<ul id="about-img-grid">
							<li 
								*ngFor="let item of aboutImgGrid" 
								[style.background-color]="item ? item.fields.imgFileBgColor : null"
								[style]="item ? item.fields.imgFileCSS : null"
							>
								<img *ngIf="item?.fields?.imgFile" [src]="item.fields.imgFile.fields.file.url" [alt]="item.fields.imgFile.fields.file.fileName" />
							</li>
						</ul>
					</div>
				</div>
				<ng-template #noAbout>
					<div *ngIf="!about?.fields" id="no-about">
						<p>Sorry, about section not found.</p>
					</div>
				</ng-template>
			} @placeholder {
				<div class="defer-ph"></div>
			}
			@defer (on viewport; when forceLoad) {
				<div id="home-about-bottom" @deferState>
					<app-social
						heading="Let&rsquo;s make it official"
						subheading="Follow me on these platforms <br />(or take a look at my r&eacute;sum&eacute;)  below:"
						enabled="linkedin, twitter, behance, resume"
					>
					</app-social>
				</div>
			} @placeholder {
				<div class="defer-ph"></div>
			}
		</div>
	</div>
	<div class="clearfix"></div>
	<div *ngIf="about?.fields && aboutState" [@aboutState]="aboutState" id="ha-full" [attr.data-content]="about.fields.title" (click)="closeAbout($event, false);">
		<div #aboutMain [ngStyle]="{'top': aboutTop + 'px'}" id="ha-full-main">
			<div id="hafm-top">
				<a class="about-close" [attr.data-content]="about.fields.title" href="#" (click)="closeAbout($event); false;"><img src="../../../../assets/images/close-gold-001.svg" width="40" alt="About Close"></a>
			</div>
			<div class="clearfix"></div>
			<div class="about-main">
				<h3 [innerHTML]="about.fields.subtitle"></h3>
				<p class="about-entry" [innerHTML]="contentService.docToHTML(about.fields.entry)"></p>
			</div>
		</div>
	</div>
</section>